import { IS_DEVNET, IS_TESTNET } from '@shared/utils/constant'
import gitVersion from '@/app/json/gitVersion.json'
import devnetTokens from '@/app/json/tokens/devnet.json'
import testnetTokens from '@/app/json/tokens/testnet.json'
import mainnetTokens from '@/app/json/tokens/mainnet.json'
import devnetSwapRoutes from '@/app/json/swap/devnet.json'
import mainnetSwapRoutes from '@/app/json/swap/mainnet.json'
import testnetSwapRoutes from '@/app/json/swap/testnet.json'

export const getTokens = () => {
  if (IS_DEVNET) {
    return devnetTokens
  }

  if (IS_TESTNET) {
    return testnetTokens
  }

  return mainnetTokens
}

export const getSwapRoutes = () => {
  if (IS_DEVNET) {
    return devnetSwapRoutes
  }

  if (IS_TESTNET) {
    return testnetSwapRoutes
  }

  return mainnetSwapRoutes
}

export const tokens = getTokens()
export const swapRoutes = getSwapRoutes()

export const gitBuild = () => {
  return (
    gitVersion || {
      branch: 'master',
      tag: 'v0.0.0',
      gitTagLink: '',
      logs: []
    }
  )
}
